import toggleVisibility from '../toggleVisibility';

const updateSelectedVariant = ({ variant, variantInventory = [], isBundleProduct = false, elements = {}, strings = {} }) => {
  const {
    productPreOrderMsg,
    productSoldInfo,
    productControls,
    klaviyoBIS,
    atcButtonMsg
  } = elements;

  const current = variantInventory.find(v => v.id === variant.id);
  const isPreOrder = !isBundleProduct && current && !current.available && current.inventory_policy === 'continue';
  const isSoldOut = !isBundleProduct && !variant.available && !isPreOrder;
  const isAvailable = isBundleProduct || variant.available;

  if (productPreOrderMsg) toggleVisibility(productPreOrderMsg, isPreOrder);
  if (productSoldInfo) toggleVisibility(productSoldInfo, !isPreOrder && isAvailable);
  if (klaviyoBIS) toggleVisibility(klaviyoBIS, isSoldOut);
  if (productControls) toggleVisibility(productControls, isAvailable);

  const getAtcBtnText = () => {
    if (isSoldOut) return strings.soldOut;
    if (isPreOrder) return strings.preOrder;
    return strings.addToCart;
  };

  if (atcButtonMsg) {
    atcButtonMsg.textContent = getAtcBtnText();
  }
};

export default updateSelectedVariant;
